import { aqoraClient } from '~/services/api/aqora-client';

export const listSystemDesignAlerts = async (systemName: string) =>
  await aqoraClient.listSystemDesignAlerts({
    systemName,
  });
